import React from 'react';

import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {AppButton} from '../../Button';
import {ContentWrapper, MaxWidthContainer} from '../../Layout';
import Article from '../Article';
import InstructionStepsList from './components/InstructionStepsList';

const InstructionModalTemplate = (props) => {
    const {
        subTitleText,
        subTitleKey,
        subTitleClassName,
        children,
        className,
        instructionList,
        instructionText,
        instructionListClassName,
        articleProps,
        buttonProps,
        instructionButtonProps,
        skipButtonProps,
        instructionContent,
    } = props;
    const localizedStrings = getLocalizedStrings();
    const subTitle = subTitleText || localizedStrings[subTitleKey];

    return (
        <MaxWidthContainer size='m' className={className}>
            <ContentWrapper className='md:mx-8 lg:mx-0'>
                <Article {...articleProps} />
            </ContentWrapper>
            {instructionList && (
                <InstructionStepsList
                    subTitle={subTitle}
                    subTitleClassName={subTitleClassName}
                    instructionKey={instructionList}
                    instructionText={instructionText}
                    instructionButton={instructionButtonProps}
                    skipButton={skipButtonProps}
                    className={instructionListClassName}
                >
                    {instructionContent}
                </InstructionStepsList>
            )}
            {buttonProps && (
                <div className='w-full md:w-auto'>
                    <ContentWrapper>
                        <AppButton {...buttonProps} />
                    </ContentWrapper>
                </div>
            )}
            {children}
        </MaxWidthContainer>
    );
};

export default InstructionModalTemplate;
